export const SET_NUMBER = 'SET_NUMBER'
export const RESET_NUMBER = 'RESET_NUMBER'
